import { render, staticRenderFns } from "./ListasPrecioComparar.vue?vue&type=template&id=2a10a5fe&scoped=true&"
import script from "./ListasPrecioComparar.vue?vue&type=script&lang=js&"
export * from "./ListasPrecioComparar.vue?vue&type=script&lang=js&"
import style0 from "./ListasPrecioComparar.vue?vue&type=style&index=0&id=2a10a5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10a5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VFadeTransition,VIcon,VProgressCircular,VRow})
